export default __webpack_public_path__ + "static/media/motherInLaw.e7ffbef0.svg";